// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__1DDwY","load3":"Spinner__load3__3wkyi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 116
// module chunks = 0